import styled from 'styled-components';

import Button from 'components/shared/Button';
import ButtonGroup from 'components/shared/ButtonGroup';
import { colors } from 'styles/theme/colors';
import { BodySmall } from 'styles/typography';

import { Scenario, SCENARIOS } from './types';

type Props = {
  scenario: Scenario;
  relinkable?: boolean;
  onUnlink?: () => void;
  onApprove?: () => void;
  onDeny?: () => void;
  onRelink?: () => void;
};

export default function SlideoutFooter({ scenario, relinkable, onUnlink, onApprove, onDeny, onRelink }: Props) {
  if (scenario === SCENARIOS.REMOVE_INDIVIDUAL) {
    return null;
  }

  return (
    <FooterContainer>
      {scenario === SCENARIOS.UNLINK_TWO && (
        <Button variant='outline-danger' onClick={onUnlink}>
          Unlink Records
        </Button>
      )}

      {scenario === SCENARIOS.PENDING_REVIEW && (
        <ButtonRow>
          <Button variant='outline-danger' onClick={onDeny}>
            Deny Match
          </Button>
          <Button onClick={onApprove}>Approve Match</Button>
        </ButtonRow>
      )}

      {scenario === SCENARIOS.UNLINKED && relinkable && <Button onClick={onRelink}>Relink Records</Button>}
      {scenario === SCENARIOS.UNLINKED && !relinkable && (
        <NotRelinkableMessage>One or more patients have been linked elsewhere. Unable to relink.</NotRelinkableMessage>
      )}
    </FooterContainer>
  );
}

const FooterContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px 24px;

  > button {
    width: 100%;
  }
`;

const ButtonRow = styled(ButtonGroup)`
  display: flex;
  gap: 12px;

  > button {
    flex: 1;
  }
`;

const NotRelinkableMessage = styled(BodySmall)`
  color: ${colors.black50};
  text-align: center;
  margin: 0;
`;
